<template>
    <div class="h-100 mt-3">
        <div class="m-2">
            <b-row align-h="between">
                <b-col class="d-flex" cols="12" md="8">
                    <div class="input-icon-wrapper search">
                        <div class="saysimple-icon embeded-icon search position-absolute text-secondary" />
                        <b-form-input
                            id="search-query"
                            v-model="searchQuery"
                            :placeholder="$t('paginator.search')"
                            class="bg-light round-medium"
                        />
                    </div>

                    <b-dropdown
                        v-model="perPage"
                        v-b-tooltip.hover.bottom="$t('paginator.number-of-items-per-page')"
                        :text="`${$t('paginator.entries-capitalized')}: ${perPage.toString()}`"
                        class="per-page-selector mx-50 round-medium"
                        no-caret
                        variant="light"
                    >
                        <b-dropdown-item
                            v-for="perPageOption in perPageOptions"
                            :key="perPageOption"
                            @click="perPage = perPageOption"
                        >
                            {{ perPageOption }}
                        </b-dropdown-item>
                    </b-dropdown>
                </b-col>

                <b-col cols="auto">
                    <b-button id="contacts-add" :to="{ name: 'contacts-lists-add' }" variant="primary">
                        <font-awesome-icon class="mr-50" icon="plus" />
                        <span class="text-nowrap">{{ $t("contacts.lists.button-add") }}</span>
                    </b-button>
                </b-col>
            </b-row>
        </div>

        <b-table
            ref="refTable"
            :empty-text="$t('paginator.no-matching-records-found')"
            :fields="tableColumns"
            :items="fetchContactsLists"
            :no-sort-reset="true"
            :sort-by.sync="sortBy"
            :sort-desc.sync="isSortDirDesc"
            :table-busy="isLoading"
            class="position-relative"
            primary-key="id"
            responsive
            show-empty
        >
            <template #table-busy>
                <div class="d-flex justify-content-center my-1">
                    <b-spinner />
                </div>
            </template>

            <template #cell(name)="data">
                <strong>{{ data.item.name }}</strong>
            </template>
            <template #cell(contacts)="data">
                {{ data.item.contacts.length }}
            </template>
            <!-- Column: Actions -->
            <template #cell(actions)="data">
                <div class="text-right">
                    <b-button
                        :to="{
                            name: 'contacts-lists-edit',
                            params: { id: data.item.id },
                        }"
                        class="btn-icon mr-50"
                        variant="light"
                    >
                        <font-awesome-icon icon="pen" />
                    </b-button>
                    <b-button
                        class="btn-icon"
                        variant="light"
                        @click="deleteOne({ id: data.item.id, name: data.item.name }, refetchData)"
                    >
                        <font-awesome-icon icon="trash" />
                    </b-button>
                </div>
            </template>
        </b-table>

        <div class="mx-2 mb-2 mt-4">
            <b-row>
                <b-col
                    class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    cols="12"
                    sm="6"
                >
                    <span class="text-muted">
                        {{ $t("paginator.showing") }} {{ dataMeta.to }} {{ $t("paginator.of") }} {{ dataMeta.of }}
                        {{ $t("paginator.entries") }}
                    </span>
                </b-col>

                <b-col class="d-flex align-items-center justify-content-center justify-content-sm-end" cols="12" sm="6">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="total"
                        class="mb-0 mt-1 mt-sm-0"
                        first-number
                        last-number
                        next-class="next-item"
                        prev-class="prev-item"
                        size="sm"
                    >
                        <template #prev-text>
                            <font-awesome-icon icon="chevron-left" size="lg" />
                        </template>
                        <template #next-text>
                            <font-awesome-icon icon="chevron-right" size="lg" />
                        </template>
                    </b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import {
    BAlert,
    BButton,
    BCard,
    BCol,
    BContainer,
    BDropdown,
    BDropdownItem,
    BFormInput,
    BLink,
    BPagination,
    BPopover,
    BRow,
    BSpinner,
    BTable,
    VBTooltip,
} from "bootstrap-vue";
import useContactsLists from "@/composables/useContactsLists";
import { ref } from "@vue/composition-api";

export default {
    components: {
        BAlert,
        BButton,
        BCard,
        BCol,
        BContainer,
        BDropdown,
        BDropdownItem,
        BFormInput,
        BLink,
        BPagination,
        BPopover,
        BRow,
        BTable,
        BSpinner,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    setup(_, context) {
        const bvModal = context.root.$bvModal;

        const {
            fetchContactsLists,
            deleteOne,
            refetchData,
            resolvePlatformIcon,
            transformPlatformName,
            tableColumns,
            perPage,
            currentPage,
            total,
            dataMeta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            refTable,
            isLoading,
        } = useContactsLists(bvModal, true);

        /**
         // Popover info
         */
        const popoverShow = ref(false);

        const onPopoverClose = () => {
            popoverShow.value = false;
        };

        return {
            resolvePlatformIcon,
            transformPlatformName,
            tableColumns,
            perPage,
            currentPage,
            total,
            dataMeta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            refTable,
            isLoading,
            popoverShow,
            fetchContactsLists,
            deleteOne,
            refetchData,
            onPopoverClose,
        };
    },
};
</script>
